import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

@Directive({ selector: '[file-drop]' })
export class FileDropDirective {
  @Output() uploaded = new EventEmitter<File[]>();
  @HostBinding('class.dragging') isDragging = false;

  @HostListener('drop', ['$event'])
  drop(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isDragging = false;
    const dataTransfer = getDataTransferObject(event);
    if (dataTransfer == null) {
      return;
    }
    if (dataTransfer.items == null) {
      if (dataTransfer.files == null || !dataTransfer.files.length) {
        return;
      }
      this.uploaded.emit(Array.from(dataTransfer.files));
    }
    const items = dataTransfer.items;
    if (
      !items.length ||
      !Array.from(items).every(({ kind }) => kind === 'file')
    ) {
      return;
    }
    this.uploaded.emit(Array.from(items).map(item => item.getAsFile()!));
  }

  @HostListener('dragover', ['$event'])
  dragOver(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isDragging = true;
  }

  @HostListener('dragleave', ['$event'])
  dragLeave(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isDragging = false;
  }
}

function getDataTransferObject(event: Event | any): DataTransfer {
  return event.dataTransfer
    ? event.dataTransfer
    : event.originalEvent.dataTransfer;
}
